<template>
    <div v-if="isLoading">
        <font-awesome-icon icon="spinner" spin/>
    </div>
    <form v-else @submit.prevent="save">
        <div v-if="isEditable" class="row my-3">
            <div class="col-12 text-right">
                <OmniButton
                    :disabled="isSaving"
                    :isProcessing="isSaving"
                    icon="save"
                    size="lg"
                    type="submit"
                    variant="success"
                >
                    {{ $t('omt.gui.general.action.save') }}
                </OmniButton>
            </div>
        </div>

        <b-card>
            <b-card-title class="text-uppercase">
                {{ $t('omt.gui.location-management.packaging-management.available-boxes.title') }}
            </b-card-title>

            <div class="row my-1">
                <div class="col-3">
                    <OmniCheckboxes :key="allBoxes.length" v-model="selectedBoxes" :draggable="false" :grid="false"
                                    :hideCheckboxes="!isEditable"
                                    :options="allBoxes"/>
                </div>
            </div>
        </b-card>

        <div v-if="isEditable" class="row my-3">
            <div class="col-12 text-right">
                <OmniButton
                    :disabled="isSaving"
                    :isProcessing="isSaving"
                    icon="save"
                    size="lg"
                    type="submit"
                    variant="success"
                >
                    {{ $t('omt.gui.general.action.save') }}
                </OmniButton>
            </div>
        </div>
    </form>
</template>

<script>

export default {
    components: {},
    name: "PackageManagement",

    props: {
        location: {required: false},
    },

    data() {
        return {
            isSaving: false,
            isLoading: false,
            availableBoxes: [],
            selectedBoxes: [],
            allBoxes: []
        }
    },

    computed: {
        isEditable() {
            return this.hasPermission('packaging.availableboxes.edit')
        },
    },

    mounted() {
        this.isLoading = true

        let endpoints = [
            `/api/rest/boxes`,
            `/api/rest/locations/${this.location.location_type.identifier}/${this.location.identifier}/available-boxes`,
        ];

        Promise.all(endpoints.map((endpoint) => this.$http.get(endpoint)))
            .then(
                this.$http.spread((...allData) => {
                    this.allBoxes = allData[0].data.map((box) => {
                        return {
                            text: box.identifier,
                            value: box.identifier,
                        }
                    })
                    this.selectedBoxes = allData[1].data.map((box) => box.identifier)
                    this.isLoading = false
                })
            )
            .catch(error => {
                this.$alert('Er is iets misgegaan bij het ophalen van de verpakkingsmaterialen.', 'danger');
                console.error({
                    endpoints: endpoints,
                    error: error
                });
            })
    },

    methods: {
        save() {
            this.isSaving = true;

            let endpoint = `/api/rest/locations/${this.location.location_type.identifier}/${this.location.identifier}/available-boxes`;
            let payload = {
                available_boxes: this.selectedBoxes.map((boxIdentifier) => {
                    return {identifier: boxIdentifier}
                })
            }

            this.$http.put(endpoint, payload)
                .then((response) => {
                    this.$alert('De beschikbare verpakkingsmaterialen zijn opgeslagen');
                })
                .catch(error => {
                    this.$alert('Er is iets misgegaan bij het opslaan van de verpakkingsmaterialen.', 'danger');
                    console.error({
                        endpoint: endpoint,
                        error: error,
                        payload: payload
                    });
                })
                .finally(() => {
                    this.isSaving = false;
                });

        }
    },
}
</script>
